"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8arrayToString = exports.uint8arrayFromString = void 0;
const uint8arrays_1 = require("./lib/uint8arrays");
exports.uint8arrayFromString = uint8arrays_1.default.fromString;
exports.uint8arrayToString = uint8arrays_1.default.toString;
//# sourceMappingURL=index.js.map